module.exports = __webpack_public_path__ + "img/business.ae30184d.jpg";